import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { useShoppingCartController } from 'client/controllers/cartController'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductItem } from './components/ProductItem/ProductItem'
import { OrderForm } from './components/OrderForm/OrderForm'
import { CURRENCY_SIGN } from 'lib/constants/currency'

type TProps = {}

const CheckoutPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.CheckoutPage)
  const { orderables } = useShoppingCartController()
  return (
    <ResponsiveBlock contentClassName="gap-20 py-20 text-palette-white w-full min-h-screen">
      <div className="flex flex-col flex-1">
        <OrderForm />
      </div>
      <div className="flex flex-col w-[30rem] gap-8">
        <div className="flex w-full">
          <Text tagName="span" className="font-body---20px">
            {t('summary')}
          </Text>
        </div>
        <div className="flex max-h-full overflow-auto">
          <ul className="flex flex-col w-full gap-6 flex-none">
            {orderables.map((item) => {
              return <ProductItem key={item.product.id} data={item} />
            })}
          </ul>
        </div>
        <div className="flex w-full justify-between font-body---20px">
          <Text tagName="span" className="">
            {t('total')}
          </Text>
          <Text tagName="span" className="">
            {`${CURRENCY_SIGN}${orderables.reduce((acc, item) => acc + item.product.price * item.quantity, 0)}`}
          </Text>
        </div>
      </div>
    </ResponsiveBlock>
  )
}

export { CheckoutPageContent }
